import React from 'react';

export default class SupplierEmailsList extends React.Component {
  getEmails() {
    const emailValue = this.props.rowData && this.props.rowData.email ? this.props.rowData.email : '';

    return emailValue
      .split(';')
      .map(email => email.trim())
      .filter(email => !!email);
  }

  render() {
    const emails = this.getEmails();

    if (emails.length === 0) {
      return <span />;
    }

    return (
      <div>
        {emails.map((email, index) => (
          <div key={`${email}-${index}`} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
            {email}
          </div>
        ))}
      </div>
    );
  }
}